import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { InputGroup, Button } from 'reactstrap'
import { Form } from 'react-bootstrap'
import { message } from 'antd'

import { storeWarehouseDock } from '../services'
import { handleError } from '../../../helpers'

export default function NewWarehouseDockForm({ warehouse, reload }) {
    const { handleSubmit, register, formState: { errors }, reset } = useForm({})
    const [loading, setLoading] = useState(false)

    const onSubmit = values => {
        setLoading(true)
        storeWarehouseDock({ ...values, warehouse_id: warehouse.id })
            .then(res => {
                message.success(res.data.message)
                setLoading(false)
                reset()
                reload()
            })
            .catch(error => handleError(error, setLoading))
    }

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit(onSubmit)} className='mt-10' style={{ maxWidth: '500px' }}>
                <Form.Group className='form-group'>
                    <InputGroup>
                        <Form.Control
                            {...register('name', { required: true })}
                            placeholder='Nombre del muelle nuevo'
                        />                        
                        <Button type='submit' color='primary' disabled={loading}>
                            Agregar muelle nuevo
                        </Button>
                    </InputGroup>
                    { errors.name && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
                </Form.Group>
			</Form>
		</React.Fragment>
	)
}